import { computed, ref } from 'vue'
import { useCore } from '@/composables/core'

import { useLogger } from '@booksy-com/vue-tools'
import {
  EXPERIMENTS,
  EXPERIMENT_VARIANTS,
} from './consts.js'

import {
  getExperimentVariant,
  getExperimentVariantWithRelationId,
  putExtraDataToExperimentWithRelationId,
} from '@/api/index.js'

const logger = useLogger('experiments')

const _loadedExperimentsVariants = ref({})

export function useExperiments () {
  const { store } = useCore()

  const loadExperiment = async (experimentName, options = {}) => {
    try {
      // experiment already loaded - skip it
      if (_loadedExperimentsVariants.value.hasOwnProperty(experimentName)) return

      let response

      // relation_id is used for experiments, that happen before the business is created
      // and we have no business.id yet
      if (options.hasOwnProperty('relationId')) {
        response = await getExperimentVariantWithRelationId(
          options.relationId,
          experimentName
        )
      } else {
        response = await getExperimentVariant(
          store.state.business.business.id,
          experimentName
        )
      }

      const variant = response?.data.selected_variant
      _loadedExperimentsVariants.value = {
        ..._loadedExperimentsVariants.value,
        [experimentName]: variant,
      }

      if (variant) {
        logger.debug(`experiment "${experimentName}" loaded with variant: "${variant}"`)
        return
      }
      logger.debug(`experiment "${experimentName}" not active`)
    } catch (error) {
      if (error?.response?.data?.errors?.find(e => e.field === 'experiment_name')) {
        logger.error(`experiment "${experimentName}" not implemented`)
      }
    }
  }

  const updateDataInExperimentWithRelationId = async (experimentName, relationId, data) => {
    try {
      await putExtraDataToExperimentWithRelationId(
        relationId,
        experimentName,
        data
      )
    } catch (error) {
      if (error?.response?.data?.errors?.find(e => e.field === 'experiment_name')) {
        logger.error(`experiment "${experimentName}" not implemented`)
      }
    }
  }

  const getVariant = (experimentName) =>
    computed(() => _loadedExperimentsVariants.value[experimentName] || null)

  return {
    EXPERIMENTS,
    EXPERIMENT_VARIANTS,
    loadExperiment,
    getVariant,
    updateDataInExperimentWithRelationId,
  }
}

export function clearExperiments () {
  _loadedExperimentsVariants.value = {}
  logger.debug('loaded variants cleared')
}
